import { ListFilterScreenProps } from "./useFilters";
import { useTranslation } from "react-i18next";
import { Checklist } from "shared/components";
import { Days } from "shared/types";

export const DaysOfOperationFilter = ({
  filters,
  onUpdateFilters,
}: ListFilterScreenProps) => {
  const { t } = useTranslation();

  const formattedDaysOfOperationData = Object.values(Days).map((day) => ({
    label: t(`core:LOOKUPS.DAYS.${day}_FULL`),
    value: day,
  }));

  const selectedDaysOfOperation = filters.daysOfOperation;

  const handleDaysOfOperationSelect = (days: string[]) => {
    onUpdateFilters({
      daysOfOperation: days as Days[],
    });
  };
  return (
    <Checklist
      data={formattedDaysOfOperationData}
      onValueChange={handleDaysOfOperationSelect}
      value={selectedDaysOfOperation}
    />
  );
};
